import { createCrudHooks } from '../../../shared/api/crud-hooks';
import { tiposTarefaApi } from './api';
import type { TipoTarefaDto, TipoTarefaInput, TipoTarefaListItem } from './types';

export const tiposTarefaHooks = createCrudHooks<TipoTarefaListItem, TipoTarefaDto, TipoTarefaInput>(
  {
    queryKey: ['tipos-tarefa'],
    api: tiposTarefaApi,
  },
);
